/**
 * Highlights a specific node by adding highlight classes
 * @param {Object} node - The node object to highlight
 */
export const highlightNode = node => {
  if (!node) return;

  activateGraphHighlight();

  const nodeElement = document.querySelector(`.react-flow__node[data-id="${node.id}"]`);
  nodeElement?.classList.add('node-highlighted');

  // Highlight the node title
  const nodeTitle = nodeElement?.querySelector('.node-title');
  nodeTitle?.classList.add('node-title-highlighted');
};

export const highlightChildNode = node => {
  if (!node) return;

  activateGraphHighlight();

  const nodeElement = document.querySelector(`div[data-child-node-id="${node.id}"]`);
  nodeElement?.classList.add('node-child-highlighted');
};

/**
 * Highlights an edge by adding highlight classes
 * @param {Object} edge - The edge object to highlight
 */
export const highlightEdge = edge => {
  if (!edge) return;

  activateGraphHighlight();

  const edgeElement = document.querySelector(`.react-flow__edge[data-id="${edge.id}"]`);
  edgeElement?.classList.add('edge-highlighted');

  const edgeLabelElement = document.querySelector(`.react-flow__edgelabel-renderer div[data-id="${edge.id}"]`);
  edgeLabelElement?.classList.add('edge-highlighted');
};

export const activateGraphHighlight = () => {
  const container = document.querySelector('.react-flow');
  // Add class to container to indicate highlighting is active
  container?.classList.add('graph-has-highlight');
};

/**
 * Highlights a node and all its connections (nodes and edges)
 * @param {Object} node - The node object to highlight
 * @param {Object} reactFlowInstance - React Flow instance to get graph data
 */
export const highlightConnections = (node, reactFlowInstance) => {
  if (!node || !reactFlowInstance) return;

  activateGraphHighlight();

  // Highlight the central node
  highlightNode(node);

  // Find connected edges and nodes
  const edges = reactFlowInstance.getEdges();
  const connectedNodeIds = new Set();

  // Find and highlight edges connected to the node
  edges.forEach(edge => {
    if (edge.source === node.id) {
      connectedNodeIds.add(edge.target);
      highlightEdge(edge);
    } else if (edge.target === node.id) {
      connectedNodeIds.add(edge.source);
      highlightEdge(edge);
    }
  });

  // Highlight all connected nodes
  const nodes = reactFlowInstance.getNodes();
  connectedNodeIds.forEach(connectedId => {
    const connectedNode = nodes.find(n => n.id === connectedId);
    if (connectedNode) {
      highlightNode(connectedNode);
    }
  });
};

/**
 * Highlights an edge and its connected nodes (source and target)
 * @param {Object} edge - The edge object to highlight
 * @param {Object} reactFlowInstance - React Flow instance to get graph data
 */
export const highlightEdgeAndNodes = (edge, reactFlowInstance) => {
  if (!edge || !reactFlowInstance) return;

  activateGraphHighlight();

  // Highlight the edge
  highlightEdge(edge);

  // Find and highlight source and target nodes
  const nodes = reactFlowInstance.getNodes();
  const sourceNode = nodes.find(n => n.id === edge.source);
  const targetNode = nodes.find(n => n.id === edge.target);

  if (sourceNode) highlightNode(sourceNode);
  if (targetNode) highlightNode(targetNode);
};

/**
 * Removes all highlights from the graph
 */
export const removeHighlights = () => {
  // Remove 'highlight' flag from container
  const container = document.querySelector('.react-flow');
  container?.classList.remove('graph-has-highlight');

  // Remove all highlight classes
  document.querySelectorAll('.node-highlighted').forEach(el => {
    el.classList.remove('node-highlighted');
  });

  document.querySelectorAll('.node-title-highlighted').forEach(el => {
    el.classList.remove('node-title-highlighted');
  });

  document.querySelectorAll('.node-child-highlighted').forEach(el => {
    el.classList.remove('node-child-highlighted');
  });

  document.querySelectorAll('.edge-highlighted').forEach(el => {
    el.classList.remove('edge-highlighted');
  });
};
